import { MdChargingStation } from "react-icons/md";
import emailjs from "emailjs-com";
import "../p.css";
// https://uideck.com/blog/html-contact-forms
export default function ContactUs(props) {

      function sendEmail(e) {
        e.preventDefault();
        emailjs.sendForm ('service_ra0tzqd', 'template_dcrf6kr', e.target, "K6B2QrefJnYCDCTa1")
   
        .then((result) => {
            console.log(result.text);
        }, (error) => {
            console.log(error.text);
        });
        e.target.reset()
        alert('We will work on your request ASAP.')
    }

    var ms = new Date().getTime() + 86400000;
    var tomorrow = new Date(ms).toLocaleString().slice(0, 9)
  return (
    <div className="container2" >
      <div className="form-container">
        <div className="right-container">
          <div className="right-inner-container">
            <form onSubmit={sendEmail}>
            <div className="top-container">
          <div className="top-inner-container">
          <h2 style={{ marginTop:-20, color:"white", textAlign:"center"}} className="form-title">Contact</h2>
            <p style={{color:"white", marginTop:-10,textAlign:"center"}}>
              Whether you have a question, want to start a project or simply
              want to connect.
            </p>

          </div>
        </div>

              <div style={{   padding:10, borderRadius:10}}>
              <input style={{backgroundColor:"#efd2f3c2", borderRadius:8}}type="text" className="for" placeholder="Subject" name="to_name"/>
              <input style={{backgroundColor:"#efd2f3c2", borderRadius:8}}type="text" className="for" placeholder="Your name" name="from_name" />
              <input style={{backgroundColor:"#efd2f3c2", borderRadius:8}}type="email" className="for" placeholder="Your Email Address" name="from_email"/>
              <textarea style={{backgroundColor:"#efd2f3c2", borderRadius:8}}className="fo" id="" cols="30" rows="4" placeholder="Your message..." name="message"></textarea>
          
              </div>
              <input  id ="ptr" type="submit" className="btn" value="Send Message"></input>
             
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}



